import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "store/store";
import { QueryState } from "./type";
import { Lang, USER_TYPE } from "types";
import { FORM_REQUEST_TYPE } from "features/webapp/form-request/type";
import { TRANSACTION_TYPE } from "constants/constants";
import { subscriptionTransactionDefaultQuery } from "features/merchant/tabs/subscription-billing-infor/Search";

export const queryDefault = {
	skip: 0,
	take: 10,
};

export const carQueryDefault = {
	skip: 0,
	take: 10,
	sortColumn: "createdAt",
	order: "DESC",
};

export const carAppointmentsQueryDefault = {
	skip: 0,
	take: 10,
};

export const categoryQueryDefault = {
	skip: 0,
	take: 10,
	name: "",
	status: null,
	sortColumn: "id",
	order: "desc",
	language: "en",
};

export const serviceCategoryQueryDefault = {
	skip: 0,
	take: 10,
	name: null,
	status: null,
	language: "en",
};
export const newsQueryDefault = {
	skip: 0,
	take: 10,
	sortColumn: "createdAt",
	order: "DESC",
	status: null,
};

export const bannerQueryDefault = {
	skip: 0,
	take: 10,
};

export const bannerAdsQueryDefault = {
	skip: 0,
	take: 10,
};

export const brandQueryDefault = {
	name: null,
	status: null,
	skip: 0,
	take: 10,
};

export const modelQueryDefault = {
	name: null,
	status: null,
	skip: 0,
	take: 10,
	brand: null,
};

export const staffQueryDefault = {
	fullName: null,
	phoneNumber: null,
	email: null,
	skip: 0,
	take: 10,
	status: null,
	role: null,
};

export const merchantQueryDefault = {
	skip: 0,
	take: 10,
	status: null,
	fullName: null,
	phoneNumber: null,
	email: null,
};

export const showroomQueryDefault = {
	skip: 0,
	take: 10,
	name: "",
	phone: "",
};

export const customerQueryDefault = {
	skip: 0,
	take: 10,
	fullName: null,
	phoneNumber: null,
	email: null,
	status: null,
};

export const personalAppointmentQueryDefault = {
	id: 0,
	skip: 0,
	take: 10,
	textSearch: null,
	startDate: null,
	endDate: null,
	status: null,
	language: "en",
	showroom: null,
};

export const personalPurchaseQueryDefault = {
	id: 0,
	skip: 0,
	take: 10,
	bookingId: null,
	startDate: null,
	endDate: null,
	status: null,
	showroom: null,
};

export const appointmentQueryDefault = {
	skip: 0,
	take: 10,
	textSearch: null,
	bookingId: null,
	startDate: null,
	endDate: null,
	status: null,
	customer: null,
	showroom: null,
};

export const carCareAppointmentQueryDefault = {
	skip: 0,
	take: 10,
	type: TRANSACTION_TYPE.carWash.key,
};

export const purchaseQueryDefault = {
	skip: 0,
	take: 10,
	bookingId: null,
	id: null,
	startDate: null,
	endDate: null,
	status: null,
	customer: null,
};

export const serviceQueryDefault = {
	name: null,
	skip: 0,
	take: 10,
	status: null,
	language: "en",
};

export const surveyQueryDefault = {
	skip: 0,
	take: 10,
	bookingId: null,
};

export const popupQueryDefault = {
	skip: 0,
	take: 10,
	status: null,
	language: "en" as Lang,
	sortColumn: "createdAt",
	sortOrder: "DESC",
};

export const notificationQueryDefault = {
	skip: 0,
	take: 10,
	status: null,
	language: "en" as Lang,
};

export const announcementQueryDefault = {
	skip: 0,
	take: 10,
	status: null,
	language: "en" as Lang,
};

export const contactSupportQueryDefault = {
	skip: 0,
	take: 10,
};

export const merchantRequestQueryDefault = {
	skip: 0,
	take: 10,
	status: null,
	language: "en" as Lang,
};

export const affiliateTransactionQueryDefault = {
	skip: 0,
	take: 10,
};

export const collaboratorQueryDefault = {
	fullName: "",
	email: "",
	skip: 0,
	take: 10,
};

export const affiliatePaymentQueryDefault = {
	skip: 0,
	take: 10,
	status: null,
	language: "en" as Lang,
};

export const postQueryDefault = {
	skip: 0,
	take: 10,
};

export const loyaltyCampaignQueryDefault = {
	skip: 0,
	take: 10,
};

export const formRequestQueryDefault = {
	skip: 0,
	take: 10,
	name: null,
	status: null,
	type: null,
	types: [
		FORM_REQUEST_TYPE.SERVICE_REQUEST,
		FORM_REQUEST_TYPE.CAR_REQUEST,
		FORM_REQUEST_TYPE.CONTACT,
		FORM_REQUEST_TYPE.PRODUCT_REQUEST,
		FORM_REQUEST_TYPE.CAR_CARE_SERVICE,
		FORM_REQUEST_TYPE.SELL_YOUR_CAR,
		FORM_REQUEST_TYPE.IMPORT_CAR,
	],
	refId: "",
};
export const investmentQueryDefault = {
	skip: 0,
	take: 10,
	name: null,
	status: null,
	type: FORM_REQUEST_TYPE.INVESTMENT,
};

export const auctionQueryDefault = {
	skip: 0,
	take: 10,
};

export const subscriptionPackageDefault = {
	skip: 0,
	take: 10,
};

export const reconciliationQueryDefault = {
	skip: 0,
	take: 10,
};

export const partnerQueryDefault = {
	skip: 0,
	take: 10,
	name: "",
	status: null,
};

const initialState: QueryState = {
	car: carQueryDefault,
	carAppointmens: carAppointmentsQueryDefault,
	category: categoryQueryDefault,
	customer: customerQueryDefault,
	purchase: purchaseQueryDefault,
	personalAppointment: personalAppointmentQueryDefault,
	service: serviceQueryDefault,
	appointment: appointmentQueryDefault,
	carCareAppointment: carCareAppointmentQueryDefault,
	personalPurchase: personalPurchaseQueryDefault,
	serviceCategory: serviceCategoryQueryDefault,
	news: newsQueryDefault,
	banner: bannerQueryDefault,
	bannerAd: bannerQueryDefault,
	brand: brandQueryDefault,
	model: modelQueryDefault,
	staff: staffQueryDefault,
	merchant: merchantQueryDefault,
	showroom: showroomQueryDefault,
	survey: surveyQueryDefault,
	popup: popupQueryDefault,
	notification: notificationQueryDefault,
	announcement: announcementQueryDefault,
	contactSupport: contactSupportQueryDefault,
	merchantRequest: merchantRequestQueryDefault,
	affiliateTransaction: affiliateTransactionQueryDefault,
	collaborator: collaboratorQueryDefault,
	affiliatePayment: affiliatePaymentQueryDefault,
	post: postQueryDefault,
	postComment: queryDefault,
	voucherCustomerLiberty: queryDefault,
	voucherCustomerMerchant: queryDefault,
	voucherMerchant: queryDefault,
	voucherCode: queryDefault,
	campaign: loyaltyCampaignQueryDefault,
	partType: {
		...queryDefault,
		status: undefined,
	},
	merchantCarPart: {
		...queryDefault,
	},
	hotSale: {
		...queryDefault,
	},
	formRequest: formRequestQueryDefault,
	investment: investmentQueryDefault,
	auction: auctionQueryDefault,
	subscriptionPackage: subscriptionPackageDefault,
	reconciliation: reconciliationQueryDefault,
	carCareCategory: queryDefault,
	subscriptionTransaction: subscriptionTransactionDefaultQuery,
	partner: partnerQueryDefault,
	commissionPolicy: queryDefault,
	conversion: queryDefault,
	supercar: queryDefault,
};

export const filterSlice = createSlice({
	name: "filter",
	initialState,
	reducers: {
		updateCarFilter: (state, action) => {
			state.car = action.payload;
		},
		updateCarAppointmentsFilter: (state, action) => {
			state.carAppointmens = action.payload;
		},
		updateCategoryFilter: (state, action) => {
			state.category = action.payload;
		},
		updateServiceCategoryFilter: (state, action) => {
			state.serviceCategory = action.payload;
		},
		updateCustomerFilter: (state, action) => {
			state.customer = action.payload;
		},
		updatePersonalAppointmentFilter: (state, action) => {
			state.personalAppointment = action.payload;
		},
		updatePersonalPurchaseFilter: (state, action) => {
			state.personalPurchase = action.payload;
		},
		updateAppointmentFilter: (state, action) => {
			state.appointment = action.payload;
		},
		updateCarCareAppointmentFilter: (state, action) => {
			state.carCareAppointment = action.payload;
		},
		updateServiceFilter: (state, action) => {
			state.service = action.payload;
		},
		updatePurchaseFilter: (state, action) => {
			state.purchase = action.payload;
		},
		setNewsFilter: (state, action) => {
			state.news = action.payload;
		},
		setBannerFilter: (state, action) => {
			state.banner = action.payload;
		},
		setBannerAdFilter: (state, action) => {
			state.bannerAd = action.payload;
		},
		setBrandFilter: (state, action) => {
			state.brand = action.payload;
		},
		setModelFilter: (state, action) => {
			state.model = action.payload;
		},
		setStaffFilter: (state, action) => {
			state.staff = action.payload;
		},
		setMerchantFilter: (state, action) => {
			state.merchant = action.payload;
		},
		setShowroomFilter: (state, action) => {
			state.showroom = action.payload;
		},
		setSurveyFilter: (state, action) => {
			state.survey = action.payload;
		},
		setPopupFilter: (state, action) => {
			state.popup = action.payload;
		},
		setNotificationFilter: (state, action) => {
			state.notification = action.payload;
		},
		setAnnouncementFilter: (state, action) => {
			state.announcement = action.payload;
		},
		setContactSupportFilter: (state, action) => {
			state.contactSupport = action.payload;
		},
		setMerchantRequestFilter: (state, action) => {
			state.merchantRequest = action.payload;
		},
		setAffiliateTransactionFilter: (state, action) => {
			state.affiliateTransaction = action.payload;
		},
		setCollaboratorFilter: (state, action) => {
			state.collaborator = action.payload;
		},
		setAffiliatePaymentFilter: (state, action) => {
			state.affiliatePayment = action.payload;
		},
		setPostFilter: (state, action) => {
			state.post = action.payload;
		},
		setPostCommentFilter: (state, action) => {
			state.postComment = action.payload;
		},
		setVoucherCustomerLibertyFilter: (state, action) => {
			state.voucherCustomerLiberty = action.payload;
		},
		setVoucherCustomerMerchantFilter: (state, action) => {
			state.voucherCustomerMerchant = action.payload;
		},
		setVoucherMerchantFilter: (state, action) => {
			state.voucherMerchant = action.payload;
		},
		setVoucherCodeFilter: (state, action) => {
			state.voucherCode = action.payload;
		},
		setCampaignFilter: (state, action) => {
			state.campaign = action.payload;
		},
		setPartTypeFilter: (state, action) => {
			state.partType = action.payload;
		},
		setMerchantCarPartFilter: (state, action) => {
			state.merchantCarPart = action.payload;
		},
		setHotSaleFilter: (state, action) => {
			state.hotSale = action.payload;
		},
		setFormRequestFilter: (state, action) => {
			state.formRequest = action.payload;
		},
		setInvestmentFilter: (state, action) => {
			state.investment = action.payload;
		},
		setAuctionFilter: (state, action) => {
			state.auction = action.payload;
		},
		setSubscriptionPackageFilter: (state, action) => {
			state.subscriptionPackage = action.payload;
		},
		setReconciliationFilter: (state, action) => {
			state.reconciliation = action.payload;
		},
		setCarCareCategoryFilter: (state, action) => {
			state.carCareCategory = action.payload;
		},
		setSubscriptionTransactionFilter: (state, action) => {
			state.subscriptionTransaction = action.payload;
		},
		setPartnerFilter: (state, action) => {
			state.partner = action.payload;
		},
		setCommissionPolicyFilter: (state, action) => {
			state.commissionPolicy = action.payload;
		},
		setConversionFilter: (state, action) => {
			state.conversion = action.payload;
		},
		setSupercarFilter: (state, action) => {
			state.supercar = action.payload;
		},
	},
});

export const selectCarFilter = (state: RootState) => state.filter.car;
export const selectCarAppointmentsFilter = (state: RootState) =>
	state.filter.carAppointmens;
export const selectNewsFilter = (state: RootState) => state.filter.news;
export const selectBannerFilter = (state: RootState) => state.filter.banner;
export const selectBannerAdFilter = (state: RootState) => state.filter.bannerAd;
export const selectBrandFilter = (state: RootState) => state.filter.brand;
export const selectModelFilter = (state: RootState) => state.filter.model;
export const selectCategoryFilter = (state: RootState) => state.filter.category;
export const selectServiceCategoryFilter = (state: RootState) =>
	state.filter.serviceCategory;
export const selectStaffFilter = (state: RootState) => state.filter.staff;
export const selectMerchantFilter = (state: RootState) => state.filter.merchant;
export const selectShowroomFilter = (state: RootState) => state.filter.showroom;
export const selectCustomerFilter = (state: RootState) => state.filter.customer;
export const selectPersonalPurchaseFilter = (state: RootState) =>
	state.filter.personalPurchase;
export const selectPersonalAppointmentFilter = (state: RootState) =>
	state.filter.personalAppointment;
export const selectAppointmentFilter = (state: RootState) =>
	state.filter.appointment;
export const selectCarCareAppointmentFilter = (state: RootState) =>
	state.filter.carCareAppointment;
export const selectServiceFilter = (state: RootState) => state.filter.service;
export const selectPurchaseFilter = (state: RootState) => state.filter.purchase;
export const selectSurveyFilter = (state: RootState) => state.filter.survey;
export const selectPopupFilter = (state: RootState) => state.filter.popup;
export const selectNotificationFilter = (state: RootState) =>
	state.filter.notification;
export const selectAnnouncementFilter = (state: RootState) =>
	state.filter.announcement;
export const selectContactSupportFilter = (state: RootState) =>
	state.filter.contactSupport;
export const selectMerchantRequestFilter = (state: RootState) =>
	state.filter.merchantRequest;
export const selectAffiliateTransactionFilter = (state: RootState) =>
	state.filter.affiliateTransaction;
export const selectCollaboratorFilter = (state: RootState) =>
	state.filter.collaborator;
export const selectAffiliatePaymentFilter = (state: RootState) =>
	state.filter.affiliatePayment;
export const selectPostFilter = (state: RootState) => state.filter.post;
export const selectPostCommentFilter = (state: RootState) =>
	state.filter.postComment;
export const selectVoucherCustomerLibertyFilter = (state: RootState) =>
	state.filter.voucherCustomerLiberty;
export const selectVoucherCustomerMerchantFilter = (state: RootState) =>
	state.filter.voucherCustomerMerchant;
export const selectVoucherMerchantFilter = (state: RootState) =>
	state.filter.voucherMerchant;
export const selectVoucherCustomerFilter = (state: RootState) =>
	state.filter.voucherCustomerLiberty;
export const selectVoucherCodeFilter = (state: RootState) =>
	state.filter.voucherCode;
export const selectCampaignFilter = (state: RootState) => state.filter.campaign;
export const selectPartTypeFilter = (state: RootState) => state.filter.partType;
export const selectMerchantCarPartFilter = (state: RootState) =>
	state.filter.merchantCarPart;
export const selectHotSaleFilter = (state: RootState) => state.filter.hotSale;
export const selectFormRequestFilter = (state: RootState) =>
	state.filter.formRequest;
export const selectInvestmentFilter = (state: RootState) =>
	state.filter.investment;
export const selectAuctionFilter = (state: RootState) => state.filter.auction;
export const selectPackageSubscriptionFilter = (state: RootState) =>
	state.filter.subscriptionPackage;
export const selectReconciliationFilter = (state: RootState) =>
	state.filter.reconciliation;
export const selectCarCareCategoryFilter = (state: RootState) =>
	state.filter.carCareCategory;
export const selectSubscriptionTransactionFilter = (state: RootState) =>
	state.filter.subscriptionTransaction;
export const selectPartnerFilter = (state: RootState) => state.filter.partner;
export const selectCommissionPolicyFilter = (state: RootState) =>
	state.filter.commissionPolicy;
export const selectConversionFilter = (state: RootState) =>
	state.filter.conversion;
export const selectSupercarFilter = (state: RootState) => state.filter.supercar;

export const {
	updateCarFilter,
	updateCarAppointmentsFilter,
	updateCategoryFilter,
	updateServiceCategoryFilter,
	updateCustomerFilter,
	updatePersonalAppointmentFilter,
	updatePersonalPurchaseFilter,
	updateAppointmentFilter,
	updateCarCareAppointmentFilter,
	updatePurchaseFilter,
	updateServiceFilter,
	setNewsFilter,
	setBannerFilter,
	setBannerAdFilter,
	setBrandFilter,
	setModelFilter,
	setStaffFilter,
	setMerchantFilter,
	setShowroomFilter,
	setSurveyFilter,
	setPopupFilter,
	setNotificationFilter,
	setAnnouncementFilter,
	setContactSupportFilter,
	setMerchantRequestFilter,
	setAffiliateTransactionFilter,
	setCollaboratorFilter,
	setAffiliatePaymentFilter,
	setPostFilter,
	setPostCommentFilter,
	setVoucherCustomerLibertyFilter,
	setVoucherCustomerMerchantFilter,
	setVoucherMerchantFilter,
	setVoucherCodeFilter,
	setCampaignFilter,
	setPartTypeFilter,
	setMerchantCarPartFilter,
	setHotSaleFilter,
	setFormRequestFilter,
	setInvestmentFilter,
	setAuctionFilter,
	setSubscriptionPackageFilter,
	setReconciliationFilter,
	setCarCareCategoryFilter,
	setSubscriptionTransactionFilter,
	setPartnerFilter,
	setCommissionPolicyFilter,
	setConversionFilter,
	setSupercarFilter,
} = filterSlice.actions;

export default filterSlice.reducer;
